'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgSymbol = exports.SvgImage = exports.twitter = exports.sms = exports.shrink = exports.prev = exports.next = exports.link = exports.fbmessenger = exports.facebook = exports.expand = exports.email = exports.close = undefined;

var _close = require('./icons/close');

Object.defineProperty(exports, 'close', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_close).default;
  }
});

var _email = require('./icons/email');

Object.defineProperty(exports, 'email', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_email).default;
  }
});

var _expand = require('./icons/expand');

Object.defineProperty(exports, 'expand', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_expand).default;
  }
});

var _facebook = require('./icons/facebook');

Object.defineProperty(exports, 'facebook', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_facebook).default;
  }
});

var _fbmessenger = require('./icons/fbmessenger');

Object.defineProperty(exports, 'fbmessenger', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_fbmessenger).default;
  }
});

var _link = require('./icons/link');

Object.defineProperty(exports, 'link', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_link).default;
  }
});

var _next = require('./icons/next');

Object.defineProperty(exports, 'next', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_next).default;
  }
});

var _prev = require('./icons/prev');

Object.defineProperty(exports, 'prev', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_prev).default;
  }
});

var _shrink = require('./icons/shrink');

Object.defineProperty(exports, 'shrink', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_shrink).default;
  }
});

var _sms = require('./icons/sms');

Object.defineProperty(exports, 'sms', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sms).default;
  }
});

var _twitter = require('./icons/twitter');

Object.defineProperty(exports, 'twitter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_twitter).default;
  }
});

var _themeProvider = require('@spp/theme-provider');

var _client = require('./targets/client');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeProvider.themer)('@spp/ui-svg')(_client.SvgImage);
exports.SvgImage = _client.SvgImage;
exports.SvgSymbol = _client.SvgSymbol;
//# sourceMappingURL=browser.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-svg/lib/cjs/browser.js
 ** module id = 304
 ** module chunks = 1
 **/